export const pickBy = <T extends Record<string, T[keyof T]>>(
  obj: T,
  fn: (key: keyof T, value: T[keyof T]) => boolean,
): Partial<T> => Object.fromEntries(Object.entries(obj).filter(([k, v]) => fn(k, v))) as Partial<T>;
